import { useFetchApiRequest, useFetchApiRequestAsync } from 'auth-package'
import { ManageProfile } from 'auth-package'
import { defineStore } from 'pinia'
import { EConsoleType, useConsoleMessage } from '@/composables/useConsoleMessage'

interface DeviceActivityState {
    deviceActivity: DeviceActivity[]
}

export interface DeviceActivity {
    current: boolean
    device: string
    lastAccess: number
    mobile: boolean
    os: string
    osVersion: string
    sessions: Session[]
}

export interface Session {
    id: string
    browser: string
    current: boolean
    clients: Client[]
    expires: number
    ipAddress: string
    lastAccess: number
    started: number
}

export interface Client {
    clientId: string
}

export const useDeviceActivityStore = defineStore('deviceActivity', {
    state: (): DeviceActivityState => {
        return {
            deviceActivity: []
        }
    },
    getters: {
        /**
         * Sorts the devices sessions based on the 'current' flag.
         *
         * @param state
         * @returns
         */
        getSortedDeviceActivity(state) {
            state.deviceActivity.forEach((device) => {
                device.sessions.sort((a, b) => {
                    console.log(a.current, !b.current)
                    if (a.current && !b.current) {
                        return -1
                    }
                    if (!a.current && b.current) {
                        return 1
                    }

                    return 0
                })
            })

            return state.deviceActivity
        }
    },
    actions: {
        /**
         * Get device activity from the server
         */
        async getDeviceActivity() {
            const getDeviceActivity = ManageProfile.GetDeviceActivity()

            try {
                const response: DeviceActivity[] = await useFetchApiRequestAsync(getDeviceActivity)
                this.deviceActivity = response
                useConsoleMessage(EConsoleType.SUCCESS, 'getDeviceActivity', response)
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'getDeviceActivity', error)
            }
        },
        /**
         * Delete session
         *
         * @param sessionId
         */
        async deleteSession(sessionId: string) {
            const deleteSession = ManageProfile.DeleteSession()
            deleteSession.setParameters({
                sessionId: sessionId
            })

            try {
                const response: any = await useFetchApiRequestAsync(deleteSession)
                this.getDeviceActivity()

                useConsoleMessage(EConsoleType.SUCCESS, 'deleteSession', response)
            } catch (error: any) {
                useConsoleMessage(EConsoleType.ERROR, 'deleteSession', error)
            }
        }
    }
})
